import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';
import { Modal } from 'components/Modal';

interface Props {
  onCancel?: (value: string) => void;
  onConfirm?: (value: string) => void;
  isOpen: boolean;
  className?: string;
  hideCancel?: boolean;
  hideConfirm?: boolean;
}

interface State {
  current: number;
}

export default class Prompt extends React.Component<any, State> {

 	public state: State = {
    current: this.props.defaultIndex || 0
  };

	public render() {
    	const { className, isOpen, title, hideCancel, hideConfirm, onCancel, onConfirm, cancelText, confirmText } = this.props;
      const { current } = this.state;
    	return (
        <Modal isOpen={isOpen} className={cx(styles.Modal, className)}>
          
          <div className={styles.body}>{this.props.children}</div>
          <div className={styles.footer}>
            {!hideCancel && (
              <div className={styles.button} onClick={onCancel}>
                <div className={styles.text}>{cancelText || '取消'}</div>
              </div>
            )}
            {!hideConfirm && (
              <div className={cx(styles.button, styles.confirm)} onClick={onConfirm}>
                <div className={styles.text}>{confirmText || '确认'}</div>
              </div>
            )}
          </div>
        </Modal>
    	)
  }
}
